import cn from 'classnames';
import * as React from 'react';

import { Info } from './components/Info';
import { UndergroundStations } from './components/UndergroundStations';
import * as styles from './styles.css';
import { ETestId } from '../../constants';
import { ButtonsContainer } from '../../containers/Buttons';
import { CarouselContainer } from '../../containers/Carousel';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { Labels } from '../Labels';
import { Address } from '../OfferCard/components/Address';
import { Rating } from '../OfferCard/components/Rating';

interface IOfferCardPreviewProps {
  offer: IDailyRentOfferForMobileSite;
  offerLink: string;
  className?: string;
  hasDates: boolean;
  isCompact?: boolean;
  narrowButtons?: boolean;
  carouselControls?: React.ReactNode;
  showButtons?: boolean;
  onSlideChange(): void;
  onCardClick(): void;
  onMoreClick(): void;
  onBookClick(): void;
  onCallClick(): void;
  onChatClick(): void;
}

export const OfferCardPreview = ({
  offer,
  offerLink,
  className,
  hasDates,
  isCompact = false,
  carouselControls,
  narrowButtons = false,
  showButtons,
  onSlideChange,
  onCardClick,
  onMoreClick,
  onBookClick,
  onCallClick,
  onChatClick,
}: IOfferCardPreviewProps) => {
  const hasRatingOrReviews = Boolean(offer.rating || offer.reviewsCount);
  const hasCarouselControls = Boolean(carouselControls);
  const { geo } = offer;
  const { undergrounds } = geo;
  const hasMetro = undergrounds.length ? !!undergrounds[0] : null;

  return (
    <div
      data-testid={ETestId.OfferPreview}
      data-partner={offer.isCianPartner}
      className={cn(styles['root'], className)}
    >
      <CarouselContainer
        containerClassName={styles['carousel-container']}
        className={cn(styles['carousel'], isCompact && styles['carousel--compact'])}
        offer={offer}
        offerLink={offerLink}
        onSlideChange={onSlideChange}
        onClick={onCardClick}
        extraControls={
          hasCarouselControls && (
            <div className={styles['modal-controls']}>
              <div className={styles['button-container']}>{carouselControls}</div>
            </div>
          )
        }
      />
      {/* draggable=false: иначе зажатие мышью на лейблах запускает нативный drag ссылки и ломает drag-scroll (useDragScroll в Labels) */}
      <a
        className={styles['content']}
        draggable={false}
        onClick={onCardClick}
        href={offerLink}
        target="_blank"
        rel="noopener noreferrer"
        data-linkname="link_to_card"
      >
        <Labels className={styles['labels']} labels={offer.photoLabels} isScrollEnabled />
        <Info {...offer} hasDates={hasDates} hasRating={hasRatingOrReviews} isCompact={isCompact} />
        <Rating className={styles['rating']} offer={offer} />
        {hasMetro ? (
          <UndergroundStations {...offer} />
        ) : (
          <div className={styles['address']}>
            <Address address={offer.geo.address} />
          </div>
        )}
      </a>
      {showButtons && (
        <ButtonsContainer
          className={styles['buttons-container']}
          offer={offer}
          offerLink={offerLink}
          narrow={narrowButtons}
          onMoreClick={onMoreClick}
          onBookClick={onBookClick}
          onCallClick={onCallClick}
          onChatClick={onChatClick}
        />
      )}
    </div>
  );
};
